import React, { Component } from 'react';
import GoogleAnalytics from 'react-ga';

GoogleAnalytics.initialize(process.env.REACT_APP_ANALYTICS_ID);

const withTracker = (WrappedComponent, options = {}) => {
    const trackPage = page => {
        setTimeout(() => {
            GoogleAnalytics.set({
                location: `${window.location.origin}${window.location.pathname}${window.location.search}`,
                page,
                ...options,
            });
            GoogleAnalytics.pageview(page);
        });
    };

    const HOC = class extends Component {
        componentDidMount() {
            const page = this.props.location.pathname;
            trackPage(page);
        }

        componentDidUpdate(prevProps) {
            const currentPage = this.props.location.pathname;
            const previousPage = prevProps.location.pathname;

            if (currentPage !== previousPage) {
                trackPage(currentPage);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    return HOC;
};

export default withTracker;



// WEBPACK FOOTER //
// ./src/analytics.js